const RouteAction = {
  register: 'register',
  current: 'set-current',
  activeRoute: 'set-active-route',
  checkPermission: 'check-permission'
};

const InitialtRoute = {
  current: '/',
  routes: [],
  paths: [],
  userRoutes: [],
  sidebarRoutes: [],
  loginPath: '/auth/login-page/',
  logoutPath: '/auth/logout-page',
  homePath: '/admin/dashboard'
};
const fixFullpath = (nodes) => {
  if (!nodes.fullPath) nodes.fullPath = `/${nodes.path.replace('/*', '/')}`;
  nodes.fullPath = nodes.fullPath.replace('//', '/').replace('*/', '*');
  if (!nodes.fullPath.endsWith('*') && !nodes.fullPath.endsWith('/')) nodes.fullPath += '/';
  return nodes.fullPath;
};

const registerSidebarRoutes = (routes, nodes) => {
  nodes.fullPath = fixFullpath(nodes);
  if (nodes.children) {
    const newChild = nodes.children.map((item) => {
      return {
        ...item,
        fullPath: `${nodes.fullPath}${item.path}`,
        basePath: `${nodes.fullPath}`,
        sideBar: item.path.indexOf(':') === -1 && item.name,
        collapse: true
      };
    });
    nodes.children = newChild.reduce(registerSidebarRoutes, []);
    routes.push({
      ...nodes,
      open: true,
      path: nodes.path,
      fullPath: nodes.fullPath,
      children: nodes.children,
      collapse: true,
      sideBar: true
    });
  } else {
    routes.push({
      ...nodes,
      open: true,
      path: nodes.path,
      fullPath: nodes.fullPath,
      basePath: nodes.basePath,
      collapse: false,
      sideBar: nodes.path.indexOf(':') === -1 && nodes.name
      // name: nodes.fullPath
    });
  }
  return routes;
};

const register = (routes, nodes) => {
  if (!nodes.fullPath) nodes.fullPath = `/${nodes.path.replace('/*', '/')}`;
  if (!nodes.fullPath.endsWith('/')) nodes.fullPath += '/';
  if (!nodes.children) {
    routes.push({ path: nodes.path, fullPath: nodes.fullPath, permission: nodes.permission });
  }
  if (nodes.children) {
    const newChild = nodes.children.map((item) => {
      return { ...item, fullPath: `${nodes.fullPath}${item.path}` };
    });
    return newChild.reduce(register, routes);
  } else return routes;
};

const RouteReducer = (state, action) => {
  switch (action.type) {
    case RouteAction.register:
      return {
        ...state,
        routes: action.payload,
        paths: action.payload.reduce(register, [])
        // sidebarRoutes: action.payload.reduce(registerSidebarRoutes, [])
      };
    case RouteAction.current:
      return { ...state, current: action.payload };
    case RouteAction.activeRoute:
      return { ...state, activeRoute: action.payload };
    case RouteAction.checkPermission:
      return state;
    default:
      return state;
  }
};

const useLayoutRoutes = (routes, path) => {
  const filtered = routes.find((prop) => prop.path.startsWith(`${path}/`));
  if (filtered) return filtered.children;
  return [];
};
const useCurrentRouteName = (routes, path) => {
  if (!routes || !path) return null;
  path += path.endsWith('/') ? '' : '/';
  // console.log("Searched ");
  // console.log(routes);
  // console.log(path);
  const filtered = routes.find((prop) => prop.fullPath === path);
  if(filtered){
    // Extrae la ultima parte del path
    let lastSlash = filtered.fullPath.lastIndexOf('/', filtered.fullPath.length - 2);
    if(lastSlash !== -1){
      let routeName = filtered.fullPath.substring(lastSlash + 1, filtered.fullPath.length - 1);
      routeName = routeName.charAt(0).toUpperCase() + routeName.slice(1).replaceAll('-', ' ');
      return routeName;
    }

    return filtered.fullPath;
  }
  return null;
};

const activeRoute = (routes, path) => {
  if (!routes || !path) return null;
  path += path.endsWith('/') ? '' : '/';
  // console.log("Searched ");
  // console.log(routes);
  // console.log(path);
  const filtered = routes.find((prop) => prop.fullPath === path);
  if (filtered) return filtered.fullPath;
  return null;
};

export { InitialtRoute, RouteAction, useLayoutRoutes, useCurrentRouteName, activeRoute };
export default RouteReducer;
